<div id="residency">
  <div name="main" class="p-8 flex flex-col sm:w-auto bg-white">
    <div class="md:px-16">
      <div>
        <div class="pb-4">
          <h2 class="text-4xl my-2 use-rhetorik-sans">Lease Renewal</h2>
        </div>
        <div class="box-border-inactive">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">1/4</h2>
          </div>
          <div class="col-span-6">
            <h2 class="text-lg font-bold my-6 text-left">Contact Information</h2>
          </div>
          <div class="col-span-3 text-right">
            <button mat-flat-button color="accent" class="h-10 px-6 mt-6 text-right"
              routerLink="/renewalcog/renewal-review/contact-info" routerLinkActive="active">UPDATE</button>
          </div>
        </div>
        <div class="box-border-inactive">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">2/4</h2>
          </div>
          <div class="col-span-6">
            <h2 class="text-lg font-bold my-6">Other Occupant Information</h2>
            <p>Children and Pets</p>
          </div>
          <div class="col-span-3 text-right">
            <button mat-flat-button color="accent" class="h-10 px-6 mt-6 text-right"
              routerLink="/renewalcog/renewal-review/other-occupant" routerLinkActive="active">UPDATE</button>
          </div>
        </div>
        <div class="flex box-border-active pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">3/4</h2>
          </div>
          <div class="col-span-9">
            <div class="flex flex-row items-baseline">
              <div class="text-lg font-bold my-6">Roommate Info </div>
              <div class="text-sm ml-2 my-6">({{displayIndex}} of {{displayCount}})</div>
            </div>
          </div>
        </div>
      </div>
      <form id="roommateInfoForm" #roommateInfoForm="ngForm" class="flex flex-col pt-8">
        <div>
          <div>
            <mat-form-field class="w-full my-2">
              <mat-label>First Name</mat-label>
              <input matInput name="FirstName" id="FirstName" placeholder="First Name" required readonly
                [(ngModel)]="model.FirstName" #FirstName="ngModel">
              <mat-error>Please enter a name</mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="w-full my-2">
              <mat-label>Middle Name</mat-label>
              <input matInput name="MiddleName" id="MiddleName" placeholder="Middle Name" readonly
                [(ngModel)]="model.MiddleName" #MiddleName="ngModel">
              <mat-error>Please enter a name</mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="w-full my-2">
              <mat-label>Last Name</mat-label>
              <input matInput name="LastName" id="LastName" placeholder="Last Name" required readonly
                [(ngModel)]="model.LastName" #LastName="ngModel">
              <mat-error>Please enter a name</mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="w-full my-2">
              <mat-label>Cell Phone</mat-label>
              <input matInput name="cellPhone" id="CellPHone" placeholder="Cell Phone Number"
                [readonly]="model.IsLocked" required [(ngModel)]="model.CellPhone" #CellPhone="ngModel">
              <mat-error>Please enter a name</mat-error>
            </mat-form-field>
          </div>
          <div class="md:flex ">
            <div class="md:w-1/2 md:pr-2">
              <mat-form-field class="w-full my-2">
                <mat-label>Home Phone</mat-label>
                <input matInput name="homePhone" id="HomePhone" placeholder="Home Phone Number" required
                  [readonly]="model.IsLocked" [(ngModel)]="model.HomePhone" #HomePhone="ngModel">
                <mat-error>Please fill out this field</mat-error>
              </mat-form-field>
            </div>
            <div class="md:w-1/2 md:pl-2">
              <mat-form-field class="w-full my-2">
                <mat-label>Contact Email</mat-label>
                <input matInput name="AlternativeEmail" id="AlternativeEmail" [readonly]="model.IsLocked"
                  placeholder="Roommate Contact Email Address" email [(ngModel)]="model.AlternativeEmail"
                  #AlternativeEmail="ngModel" [email]="model.AlternativeEmail!='' && model.AlternativeEmail!=null">
                <mat-error>Please fill out this field</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="md:flex md:justify-between md:items-center ">
          <div class="col-md-6 text-left mobile-button-center">
            <button *ngIf="model.RoommateIndex != 0" mat-flat-button color="primary"
              (click)="backButton()">BACK</button>
          </div>
          <div class="text-right">
            <button *ngIf="!model.IsLocked" mat-flat-button color="primary" (click)="onSubmit()"
              [disabled]="!roommateInfoForm.form.valid"
              title="{{(!roommateInfoForm.form.valid)?' Please fill in all required information.' : ''}}">CONTINUE</button>
            <button *ngIf="model.IsLocked" mat-flat-button color="primary" (click)="onUpdateSuccess()">CONTINUE</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
